
<div class="modal-dialog installation-dialog">
  <div class="modal-content">
    <div class="modal-header">
      <h4 class="modal-title">{{ title }}</h4>
      <button class="close" type="button" (click)="cancel()">&times;</button>
    </div>
    <div class="modal-body">
      <table class="table table-responsive">
        <thead>
          <tr class="table-header-with-controls">
            <th class="step-number">#</th>
            <th>Description</th>
            <th class="step-actions">Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let step of listEdit; let idx = index; let last = last; let first = first">
            <td>{{ idx + 1 }}</td>
            <td>
              <textarea class="form-control form-control-sm" name="milestoneDescription{{idx}}" [(ngModel)]="step.description" type="text"></textarea>
            </td>
            <td>
              <button class="btn btn-outline-danger btn-sm" (click)="removeStep(idx)" type="button"><span class="oi oi-trash"></span></button>
              <button class="btn btn-outline-primary btn-sm" (click)="moveUp(idx)" type="button" [disabled]="first"><span class="oi oi-arrow-top"></span></button>
              <button class="btn btn-outline-primary btn-sm" (click)="moveDown(idx)" type="button" [disabled]="last"><span class="oi oi-arrow-bottom"></span></button>
            </td>
          </tr>
          <tr>
            <td class="text-center" colspan="3">
              <button class="btn btn-outline-primary btn-sm" (click)="addStep()" type="button"><span class="oi oi-plus"></span> Add</button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="modal-footer">
      <button class="btn btn-primary" type="button" (click)="save()">Save</button>
      <button class="btn btn-outline-secondary" type="button" (click)="cancel()">Cancel</button>
    </div>
  </div>
</div>